import {Controller} from "stimulus"
import $ from 'jquery';

export default class extends Controller {
    divCollapsable = $('#collapseContent');
    switchCheck = $('#switchBehavior');
    ariaChecked = this.switchCheck.attr('aria-checked');
    connect() {
        this.catchSwitchBehavior();
    }

    catchSwitchBehavior() {
        if (this.switchCheck.is(':checked')) {
            this.divCollapsable.show();
            this.switchCheck.prop('aria-checked', 'true')
        } else {
            this.divCollapsable.hide();
            this.switchCheck.prop('aria-checked', 'false')
        }
        this.setCookie('switchState', this.switchCheck.prop("checked"), 7 )
        console.log(this.getCookie('switchState'));
        console.log("Aria-checked:" + this.switchCheck.prop("aria-checked") + "    Propiedad checked:" + this.switchCheck.prop("checked"));
    }

    setCookie(name, value, daysToExpire) {
        const date = new Date();
        date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    getCookie(name) {
        const cookieName = name + "=";
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return null;
    }
}